import { useState } from "react";

// Components
import Modal from "components/organism/modal-v2";
import Button from "components/v1/Button";

// Assets
import { ReactComponent as XIcon } from "assets/cross.svg";
import ISofiaFull from "assets/i-sofia-full";
import ICheckRounded from "assets/i-check-rounded";

// API
import { useGetSofiaPackages } from "api/sofia-magic-studio";

const CardPricing = ({ title, price, credit, onSelect }) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      className={`p-[3px] rounded-[4px] bg-white flex-1 ${isHover ? "bg-gradient-to-r from-[#1B67DA] to-[#E11560]" : "bg-white"}`}
      onClick={onSelect}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="bg-white p-2">
        <div className="flex items-center gap-0.5">
          <ISofiaFull bgColor={isHover ? "#1B67DA" : "#252526"} />
        </div>
        <p className="text-[22px] font-inter-semibold leading-[35px] tracking-[-0.4px] text-[#252526]">
          {title}
        </p>
        <p className="text-[13px] leading-[21px] font-inter text-[#252526]">
          {price}
        </p>
        <Button
          className={`my-2 !text-[11px] w-full ${isHover ? "bg-[#1B67DA]" : "bg-[#252526]"}`}
          type="primary"
          size="s"
          text={`Dapatkan ${title}`}
          onClick={onSelect}
        />
        <div className="flex items-center gap-1">
          <ICheckRounded color={isHover ? "#02AC5B" : "#252526"} />
          <p className="text-[11px] leading-[18px] font-inter text-[#808285]">
            {credit}
          </p>
        </div>
      </div>
    </div>
  );
};

const ModalTambahKredit = ({ onSelect, onClose, isOpen, ...props }) => {
  const { data: packagesData, isLoading } = useGetSofiaPackages({ enabled: isOpen });
  const packages = packagesData?.data?.data || [];

  const formatPrice = (price) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(price);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} {...props}>
      <div
        className="w-[715px] z-[42] bg-white rounded-md border-[0.5px] border-solid border-[#ECECEC] 
        shadow-[0px_1px_3px_0px_rgba(16,16,16,0.10),_0px_1px_2px_0px_rgba(16,16,16,0.06)]"
      >
        <div className="flex justify-between px-4 py-2 border-b border-solid border-[#D8D8D9]">
          <p className="text-[17px] font-inter-semibold">Tambah Kredit</p>
          <XIcon onClick={onClose} />
        </div>

        <div className="bg-[#E6E7E8] flex items-center px-6 py-2 gap-4">
          {isLoading ? (
            <div className="flex-1 text-center py-4">
              <p className="text-[13px] text-[#808285]">Memuat paket...</p>
            </div>
          ) : (
            packages.map((pkg) => (
              <CardPricing
                key={pkg.id}
                id={pkg.id}
                title={pkg.name.replace('Sofia ', '')}
                price={formatPrice(pkg.price)}
                credit={`${pkg.credits.toLocaleString('id-ID')} kredit`}
                onSelect={() => onSelect(pkg)}
              />
            ))
          )}
        </div>
        <div className="px-4 py-2 border-b border-solid border-[#D8D8D9]">
          <p className="text-[11px] font-inter italic text-[#808285]">
            <span className="text-[#F04438]">*</span>Kredit dapat dibagikan
            kepada marketing.
          </p>
        </div>
      </div>
    </Modal>
  );
};

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null;
  return <ModalTambahKredit isOpen={isOpen} {...props} />;
};

export default Wrapper;
